<template>
  <div :style="{width: width, height: height}">
    <el-upload
        style="width: 100%;height: 100%"
        v-bind="$attrs"
        v-on="$listeners"
        :file-list="files"
        :on-remove="handleRemove"
        :on-success="handleUploadSuccess"
        :on-exceed="handleExceed">
      <slot>
        <i class="el-icon-plus"></i>
      </slot>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "UploadFile",
  model: {
    event: "change",
    prop: "value"
  },
  props: {
    value: {
      type: [String, Array],
      default: "",
    },

    onSuccess: { // 上传成功回调
      type: Function,
      default: () => {},
    },

    onRemove: { // 删除回调
      type: Function,
      default: () => {},
    },

    // 手动处理上传结果 布尔类型
    manual: {
      type: Boolean,
      default: false,
    },

    fileList: {
      type: Array,
      default: () => [],
    },

    downloadUrl: {
      type: String,
      default: ""
    },

    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleRemove(file, fileList) {
      this.onRemove(file, fileList);
      if(this.manual) return;
      let result;
      if(typeof this.value === "string") result = this.value ? this.value.split(",") : [];
      else result = this.value;
      let delItem = file.url.split("=")[1];
      let delIndex = result.indexOf(delItem);
      result.splice(delIndex, 1);
      if(typeof this.value === "string") {
        this.$emit("change", result.join(","));
      } else {
        this.$emit("change", result);
      }
    },

    handleUploadSuccess(res, file, fileList) {
      this.onSuccess(res, file, fileList);
      if(this.manual) return;
      if(res.status !== 200) {
        this.$message.error(res?.desc || "上传失败");
        return;
      }

      // 判断 value 接收类型，字符串以 , 拼接，数组直接赋值
      if(typeof this.value === "string") {
        let result = this.value ? this.value.split(",") : [];
        result.push(res.data.code);
        this.$emit("change", result.join(","));
      } else {
        this.$emit("change", [...this.value, res.data.code]);
      }
    },



    handleExceed() {
      this.$message.warning(`只能上传${this.$attrs?.limit || 1}个文件`);
    }
  },
  computed: {
    files() {
      if(this.fileList.length) return this.fileList;

      // 判断 value 类型
      if(typeof this.value === "string" && this.value) {
        return this.value.split(",").map(item => {
          return {url: this.downloadUrl + item}
        })
      } else if(Array.isArray(this.value) && this.value.length) {
        return this.value.map(item => {
          return {url: this.downloadUrl + item};
        })
      }
      return [];
    }
  }
}
</script>

<style scoped>

/deep/ .el-upload--picture-card {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
